import ReactSwitch from 'react-switch';

import React from 'react';
import useApp from 'hooks/useApp';

interface Props {
    language?: string;
    on: boolean;
    toggle():void
}

const ToggleSwitch: React.FC<Props> = ({ language, on, toggle }) => {

    const { autoTranslateConfirm } = useApp()
 
    return (
        <ReactSwitch
            disabled={autoTranslateConfirm}
            checked={!!on}
            onChange={toggle}
            checkedIcon={false}
            uncheckedIcon={false}
            height={24}
            width={40}
            handleDiameter={18}
            onColor={'#fff'}
            offColor={'#fff'}
            onHandleColor={'#009f85'}
            offHandleColor={'#009f85'}
        />
    )
}

export default ToggleSwitch;